<template>
  <div class="dropdown-block">

    <!-- Dropdown link item -->
    <dropdown-link v-for="item in list"
                   :item="item"
                   :key="item.id"
    />
    <!---->

  </div>
</template>

<script>
import DropdownLink from 'theme/components/core/blocks/Shop/Sidebar/Dropdown/DropdownLink'

export default {
  components: {
    DropdownLink
  },
  props: {
    // List of categories
    list: {
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-block {
  margin: 6px 0 0 20px;

  display: flex;
  flex-direction: column;
}
</style>
